module.exports = __webpack_public_path__ + "static/img/图层 50.31d42879.png";